/**
 * @Description 存放所有URL
 */
const README = { //接口对象使用说明 待完善
  url: '',//url地址
  describe: '',//描述
  headers: {},//请求头
  params: {}//参数
}
const viewComment = {
  url: '/api-image-hub/teacherComment/viewComment',
  describe: '批注回显',
}
const eidtComment = {
  url: '/api-image-hub/teacherComment/eidtComment',
  describe: '批注和评分保存',
}
const stu_viewComment = {
  url: '/api-image-hub/teacherComment/stu/viewComment',
  describe: '查看老师/助教批注',
}
const queryClassRegister = {
  url: '/api-interaction/teacher/register/student/queryClassRegister',
  describe: '查看签到列表',
}
const editClassRegister = {
  url: '/api-interaction/teacher/register/student/eidtClassRegister',
  describe: '签到或取消签到',
}
const allRegister = {
  url: '/api-interaction/teacher/register/student/allRegister',
  describe: '一键全签',
}
const queryClassHour = {
  url: '/api-interaction/teacher/register/student/queryClassHour',
  describe: '查看当前签到课时',
}
const queryProvince = {
  url: '/api-user/sys/province/query',
  describe: '查询省份',
}
const sysUserInformationSave = {
  url: '/api-user/sysUserInformation/save',
  describe: '保存教师信息',
}
const sysUserInformationUpdate = {
  url: '/api-user/sysUserInformation/update',
  describe: '修改教师信息',
}
const addUntitledStemInteraction = {
  url: '/api-interaction/untitledStemInteraction/addUntitledStemInteraction',
  describe: '临时互动-老师端发布试题',
}
const endInteraction = {
  url: '/api-interaction/untitledStemInteraction/endInteraction',
  describe: '临时互动-结束互动',
}
const showUntitledStemInteraction = {
  url: '/api-interaction/untitledStemInteraction/showUntitledStemInteraction',
  describe: '临时互动-学生查询试题详情',
}
const queryStatisticsByInteraction = {
  url: '/api-interaction/untitledStemInteraction/queryStatisticsByInteraction',
  describe: '临时互动-老师查询试题详情',
}
const saveStudentAnswer = {
  url: '/api-interaction/interactionStuAnswer/eidtAnswer',
  describe: '临时互动-学生保存作答',
}
const queryFirstThree = {
  url: '/api-interaction/interactionStuAnswer/queryFirstThree',
  describe: '临时互动-查询正确手速榜',
}
const selectList = {
  url: '/api-image-hub/itCourse/selectList',
  describe: '获取课程默认环境配置入口',
}
const findDataByQuestionId = {
  url: '/api-resource/questionAnswer/findDataByQuestionId',
  describe: '获取预置内容',
}
const formRecord = {
  url: '/api-train/train/replica/formRecord',
  describe: '获取预置内容',
}
const queryNotes = {
  url: '/api-interaction/teacher/notes/queryNotes',
  describe: '查询笔记',
  params: {
    classId: '',
    courseId: '',
    catalogId: ''
  }
}
const deleteNotes = {
  url: '/api-interaction/teacher/notes/deleteNotes',
  describe: '删除笔记',
  params: {
    ids: []
  }
}
const updateNotes = {
  url: '/api-interaction/teacher/notes/updateNotes',
  describe: '修改笔记',
  params: {
    id: '',
    notesTrace: ''
  }
}
const updateIndex = {
  url: '/api-interaction/teacher/notes/updateIndex',
  describe: '拖动位置',
  params: {
    id: '',
    sort: ''
  }
}
const exportRecord = {
  url: `${process.env.BASE_API}/api-course/class/practical/stu/excel/export`,
  headers: {
    'Content-Type': undefined
  },
  describe: '导出记录',
}
const courseFindByUserType = {
  url: '/api-course/course/findByUserType',
  describe: '课程范围',
  params: {
    //如财税
    name: '',
    //0:管理员入口 1:教师入口 2:学生入口
    type: ''
  }
}
const classFindByUserType = {
  url: '/api-course/class/findByUserType',
  describe: '数据范围',
  params: {
    //如财税
    name: '',
    userId: '',
    //如12345
    courseId: '',
    //0:管理员入口 1:教师入口 2:学生入口
    type: '',
    startDate: '',//2022-10-11
    endDate: ''//2022-11-11
  }
}
const numberOfProfessionals = {
  url: '/api-data/studyNum/teacher/count',
  describe: '专业人数-老师',
  params: {
    courseId: '',
    classId: '',
    startDate: '',//2022-10-11
    endDate: ''//2022-11-11
  }
}
const numberOfProfessionalsAdmin = {
  url: '/api-data/studyNum/admin/count',
  describe: '专业人数-管理员',
  params: {
    courseId: '',
    classId: '',
    startDate: '',//2022-10-11
    endDate: ''//2022-11-11
  }
}
const getClassCount = {
  url: '/api-course/class/class/count',
  describe: '教师整体统计-班级数量',
  params: {
    courseId: '',
    startDate: '',
    endDate: '',
    //默认为空,
    classId: '',
    //开班状态 0:待开始 1:开班中 2:已结束
    status: ''
  }
}
const getStudyCount = {
  url: '/api-course/class/student/study/count',
  describe: '教师整体统计-听课学员数量',
  params: {
    courseId: '',
    startDate: '',
    endDate: '',
    //默认为空,
    classId: '',
  }
}
const getAphorism = { //get请求
  url: '/api-cms/famousQuotes/get',
  describe: '获取名言警句'
}
const getLearningRanking = {
  url: '/api-course/class/student/count',
  describe: '获取选课量排行',
  params: {
    userId: '',
    courseId: '',
    startDate: '',
    endDate: '',
    classId: '',
    pageNum: 1,
    pageSize: 10
  }
}
const findTeacherRank = {
  url: '/api-data/rank/findTeacherRank',
  describe: '获取专业排名',
  params: {
    courseId: ''
  }
}
const getClassProgress = {
  url: '/api-study/classProgress/avg',
  describe: '获取班级教学进度',
  params: {
    courseId: '',
    startDate: '',
    endDate: '',
    //老师ID，不传表示管理员统计
    userId: '',
    //默认可以不传
    classId: '',
    //0:课程实践 1:实践教学 ,如果不传则是课程平均成绩
    catalogType: ''
  }
}
const getExamProgress = {
  url: '/api-study/getExamProgress',
  describe: '获得测验平均进度',
  params: {
    courseId: '',
    startDate: '',
    endDate: '',
    //老师ID，不传表示管理员统计
    userId: '',
    //默认可以不传
    classId: '',
  }
}
const getExamPaperAvgScore = {
  url: '/api-study/getExamPaperAvgScore',
  describe: '获得测验平均分数',
  params: {
    courseId: '',
    startDate: '',
    endDate: '',
    //老师ID，不传表示管理员统计
    userId: '',
    //默认可以不传
    classId: '',
  }
}
const getNoteDiscussNum = {
  url: '/api-study/discussion/getNoteDiscussNum',
  describe: '获取讨论，笔记，回复条数',
  params: {
    courseId: '',
    startDate: '',
    endDate: '',
    //老师ID，不传表示管理员统计
    userId: '',
    classId: '',
  }
}
const getNoteCountSort = {
  url: '/api-study/getNoteCountSort',
  describe: '获取笔记排行榜',
  params: {
    courseId: '',
    startDate: '',
    endDate: '',
    //老师ID，不传表示管理员统计
    userId: '',
    classId: '',
    pageNum: 1,
    pageSize: 10
  }
}
const getDiscussCountSort = {
  url: '/api-study/discussion/getDiscussCountSort',
  describe: '获取讨论排行榜',
  params: {
    courseId: '',
    startDate: '',
    endDate: '',
    //老师ID，不传表示管理员统计
    userId: '',
    classId: '',
    pageNum: 1,
    pageSize: 10
  }
}
const findList = {
  url: '/api-data/time/findList',
  describe: '学习时长折线图',
  params: {
    //课程ID，必填
    classId: '',
    courseId: '',
    startDate: '',
    endDate: '',
  }
}
const findListInAdmin = {
  url: '/api-data/time/findListInAdmin',
  describe: '学习时长折线图-管理员',
  params: {
    //课程ID，必填
    classId: '',
    courseId: '',
    startDate: '',
    endDate: '',
    teacherUserId:''
  }
}
const findPage = {
  url: '/api-data/time/findPage',
  describe: '学生学习时长列表',
  params: {
    //课程ID，必填
    courseId: '',
    classId: '',
    pageNum: 1,
    pageSize: 10
  }
}
const getExamScoreArea = {
  url: '/api-study/getExamScoreArea',
  describe: '查询测验分数最高分-最低分-平均分',
  params: {
    courseId: '',
    startDate: '',
    endDate: '',
    //老师ID，不传表示管理员统计
    userId: '',
    classId: '',
  }
}
const getExamScoreList = {
  url: '/api-study/getExamScoreList',
  describe: '查询测验分数分布范围折线图（班级最低分, 班级平均分, 班级最高分）',
  params: {
    courseId: '',
    startDate: '',
    endDate: '',
    //老师ID，不传表示管理员统计
    userId: '',
    classId: '',
  }
}
const getClassProgressList = {
  url: '/api-study/classProgress/list',
  describe: '课程整体、课程实践、 实践教学排行',//学习进度排行
  params: {
    catalogType: '',
    courseId: '',
    startDate: '',
    endDate: '',
    //老师ID，不传表示管理员统计
    userId: '',
    classId: '',
    pageNum: 1,
    pageSize: 10
  }
}
const getTeacherList = {
  url: '/api-user/sys/user/getTeacherList',
  describe: '获取教师列表',
  params: {
    name: ''
  }
}
const queryRegisterDuration = {//get
  url: '/api-user/sys/dept/queryRegisterDuration',
  describe: '机构运行天数',
}
const queryClassByCourseId = {
  url: '/api-course/class/queryClassByCourseId',
  describe: '教学班',
  params: {
    name: '',
    status: 1,
    courseId: ''
  }
}
const selectClassNoPage = {
  url: '/api-teachingaffair/teachingClass/selectClass',
  describe: '行政班',
  params: {
    school_id: ''
  }
}
const queryAdmin = {
  url: '/api-user/sys/user/queryAdmin',
  describe: '查询管理员人数',
  params: {
    startTime: '',
    endTime: ''
  }
}
const queryTeacher = {
  url: '/api-user/sys/user/queryTeacher',
  describe: '查询教师人数',
  params: {
    startTime: '',
    endTime: ''
  }
}
const queryStudent = {
  url: '/api-user/sys/user/queryStudent',
  describe: '查询学生人数',
  params: {
    startTime: '',
    endTime: ''
  }
}
const queryMonthLyNewUser = {
  url: '/api-user/sys/user/queryMonthLyNewUser',
  describe: '根据月份查询新增注册用户',
  params: {
    timeRange: '',
    startTime: '',
    endTime: ''
  }
}

const completeTaskCount = {
  url: '/api-course/statistical/course/completeTaskCount',
  describe: '课程完成任务数',
  params: {
    classId: '',
    courseId: ''
  }
}
const findCourseScope = {
  url: '/api-course/statistical/course/findCourseScope',
  describe: '学生查询课程范围',
  params: {}
}
const findClassScope = {
  url: '/api-course/statistical/course/findClassScope',
  describe: '学生查询课程范围',
  params: {
    courseId: '',
    startDate: '',
    endDate: ''
  }
}
const classRanking = {
  url: '/api-study/statistical/study/classRanking',
  describe: '学生查询班级排名',
  params: {
    classId: '',
  }
}
const classStudyCount = {
  url: '/api-course/statistical/course/classStudyCount',
  describe: '学生班级学习统计',
  params: {
    classId: '',
    courseId: '',
    startDate: '',
    endDate: ''
  }
}
const questionCount = {
  url: '/api-course/statistical/course/questionCount',
  describe: '学生题库数量',
  params: {
    courseId: '',
  }
}
const courseTaskCount = {
  url: '/api-course/statistical/course/courseTaskCount',
  describe: '学生任务完成情况(课程和实训)',
  params: {
    classId: '',
    courseId: '',
    startDate: '',
    endDate: ''
  }
}
const noSolveQuestion = {
  url: '/api-study/statistical/study/noSolveQuestion',
  describe: '学生待解决问题',
  params: {
    classId: '',
    courseId: '',
    startDate: '',
    endDate: ''
  }
}
const examPaperAvgScore = {
  url: '/api-study/statistical/study/examPaperAvgScore',
  describe: '学生测验平均分',
  params: {
    classId: '',
    courseId: '',
    startDate: '',
    endDate: ''
  }
}
const examPaperScore = {
  url: '/api-study/statistical/study/examPaperScore',
  describe: '学生测验最高分、最低分、平均分',
  params: {
    classId: '',
    courseId: '',
    startDate: '',
    endDate: ''
  }
}
const myNote = {
  url: '/api-study/statistical/study/myNote',
  describe: '学生公开笔记数',
  params: {
    classId: '',
    courseId: '',
    startDate: '',
    endDate: ''
  }
}
const myDiscussion = {
  url: '/api-study/statistical/study/myDiscussion',
  describe: '学生讨论、回复主题和发表评论',
  params: {
    classId: '',
    courseId: '',
    startDate: '',
    endDate: ''
  }
}
const rankIngOfStudent = {
  url: '/api-course/class/rankIngOfStudent',
  describe: '学生选课量-管理员',
  params: {
    classId: '',
    courseId: '',
    startDate: '',
    endDate: '',
    pageNum: 1,
    pageSize: 10
  }
}
const rankIngOfTeacher = {
  url: '/api-course/class/rankIngOfTeacher',
  describe: '教师授课学员数-管理员',
  params: {
    classId: '',
    courseId: '',
    startDate: '',
    endDate: '',
    pageNum: 1,
    pageSize: 10
  }
}
const studentRankIng = {
  url: '/api-data/time/studentRankIng',
  describe: '学时排行-学生排行',
  params: {
    classId:'',
    courseId: '',
    startDate: '',
    endDate: '',
    isToday:'',
    pageNum: 1,
    pageSize: 10
  }
}
const classRankIng = {
  url: '/api-data/time/classRankIng',
  describe: '学时排行-教学班排行',
  params: {
    classId:'',
    courseId: '',
    startDate: '',
    endDate: '',
    isToday:'',
    pageNum: 1,
    pageSize: 10
  }
}
const studentFindList = {
  url: '/api-data/time/student/findList',
  describe: '学生课件学习时长',
  params: {
    classId:'',
    courseId: '',
    startDate: '',
    endDate: ''
  }
}
const findCourseStudyList = {
  url: '/api-data/time/student/findCourseStudyList',
  describe: '学生课件学习时长-今日学习',
  params: {
    classId:'',
    courseId: '',
    startDate: '',
    endDate: ''
  }
}
const saveLearnPath = {
  url: '/api-study/statistical/study/saveLearnPath',
  describe: '保存学习路径',
  params: {
    classId:'',
    courseId: '',
    resourceId: '',
    isEnd: '1',
    resourceType: '11',
    catalogId: '0',
    type: 0,
  }
}
const queryTeacherInCourse = {
  url: '/api-course/class/queryTeacherInCourse',
  describe: '查询班级所对应的老师',
  params: {
    courseId: ''
  }
}
const studentStatistics = {
  url: '/api-interaction/teacher/register/student/studentStatistics',
  describe: '签到统计-学员维度',
  params: {
    courseId: '',
    classId:''
  }
}

export {
  viewComment,
  eidtComment,
  stu_viewComment,
  queryClassRegister,
  editClassRegister,
  allRegister,
  queryClassHour,
  queryProvince,
  sysUserInformationSave,
  sysUserInformationUpdate,
  addUntitledStemInteraction,
  endInteraction,
  showUntitledStemInteraction,
  queryStatisticsByInteraction,
  saveStudentAnswer,
  queryFirstThree,
  selectList,
  findDataByQuestionId,
  formRecord,
  queryNotes,
  deleteNotes,
  updateNotes,
  updateIndex,
  exportRecord,
  courseFindByUserType,
  classFindByUserType,
  numberOfProfessionals,
  getClassCount,
  getStudyCount,
  getAphorism,
  getLearningRanking,
  findTeacherRank,
  getClassProgress,
  getExamProgress,
  getExamPaperAvgScore,
  getNoteDiscussNum,
  getNoteCountSort,
  getDiscussCountSort,
  findList,
  findPage,
  getExamScoreArea,
  getExamScoreList,
  getClassProgressList,
  getTeacherList,
  queryRegisterDuration,
  queryClassByCourseId,
  selectClassNoPage,
  queryAdmin,
  queryTeacher,
  queryStudent,
  queryMonthLyNewUser,
  completeTaskCount,
  findCourseScope,
  findClassScope,
  classRanking,
  classStudyCount,
  questionCount,
  courseTaskCount,
  noSolveQuestion,
  examPaperAvgScore,
  examPaperScore,
  myNote,
  myDiscussion,
  rankIngOfStudent,
  studentRankIng,
  studentFindList,
  findCourseStudyList,
  rankIngOfTeacher,
  classRankIng,
  numberOfProfessionalsAdmin,
  findListInAdmin,
  saveLearnPath,
  queryTeacherInCourse,
  studentStatistics
}



// WEBPACK FOOTER //
// ./src/api/PostUrl.js